<template>
  <button v-bind="$attrs" v-on="$listeners"><slot /></button>
</template>

<script>
export default {
  name: "AdminButton",
  inheritAttrs: false,
};
</script>
